import { ApiAccountSnapshot, ApiOperationBase } from 'api/rtk-api'
import { Currency } from 'utilities/currency'

import { Row } from '../../../pages/trade-events'
import { CashTransactionTable } from '../../cash-transaction-table'
import { DistributionTable } from '../../distribution-table'
import { ExternalTransferTable } from '../../external-transfer-table'
import { FeeOperation, FeeTable } from '../../fee-table'
import { GenericEventAssetsTable } from '../../generic-event-assets-table'
import { ReinvestmentTable } from '../../reinvestment-table'
import { ZCBTable } from '../../zcb-table'

export interface EventTablesProps {
  currency: Currency
  feeOperations: FeeOperation[]
  operation: ApiOperationBase
  row: Row
  snapshot: ApiAccountSnapshot
}

export const EventTables = ({
  currency,
  feeOperations,
  operation,
  row,
  snapshot
}: EventTablesProps) => {
  const showAssetTable = [
    'Deposit',
    'Rebalancing',
    'Redemption',
    'Withdrawal',
    'Dividend',
    'Switch In',
    'Gap Payment'
  ].includes(row.readableType)
  const showFeeTable =
    operation.type === 'FeeDeduction' || operation.type === 'TriggeredFeeDeduction'
  const showZCBTable = row.readableType === 'ZCB Rebalancing'
  const showCashInstrumentTable = row.readableType === 'Cash Rebalancing'
  const showDistributionTable = row.readableType === 'Distribution'
  const showReinvestmentTable = row.readableType === 'Reinvestment'
  const showExternalTransferTable = row.type === 'ExternalTransfer'

  return (
    <div className="mt-10">
      {showAssetTable && <GenericEventAssetsTable operation={operation} />}
      {showFeeTable && <FeeTable currency={currency} operations={feeOperations} />}
      {showZCBTable && <ZCBTable operation={operation} />}
      {showCashInstrumentTable && <CashTransactionTable operation={operation} />}
      {showDistributionTable && <DistributionTable operation={operation} />}
      {showReinvestmentTable && <ReinvestmentTable operation={operation} />}
      {showExternalTransferTable && (
        <ExternalTransferTable operation={operation} snapshot={snapshot} />
      )}
    </div>
  )
}
